import { gql } from '@apollo/client';

const planPrice_fields = `
	PlanPriceId
	Value
	Currency
`;

const software_fields = `
	SoftwareId
	Name
	AccessLink
`;

const Subscription_fields = `
	SubscriptionId
	UserGroup {
		UserGroupId
		Name
	}
	Plan {
		PlanId
		Name
	}
`;

const UserGroupType_fields = `
	UserGroupTypeId
	Name
	MembersMin
	MembersMax
`;

const OptionPrice_fields = `
	OptionPriceId
	Value
	Currency
`;

const Option_fields = `
	OptionId
	Name
	OptionPrice{
		${OptionPrice_fields}
	}
`;

const OptionIncluded_fields = `
	OptionIncludedId
	Plan {
		PlanId
		Name
	}
	Option {
		${Option_fields}
	}
`;

const UserGroup_fields = `
	UserGroupId
	UserGroupType{
		UserGroupTypeId
		Name
	}
	Name
	CustomerInvoiceText
	Organization{
		OrganizationId
		Name
	}
	UserInGroup{
		UserInGroupId
	}
	Plans{
		PlanId
		Name
	}
	Users {
		UserId
	}
	Subscription{
		SubscriptionId
	}

`;

const pricingPlan_fields = `
	PlanId
	Name
	Created
	Updated
	IsActive
	PlanPrice {
		${planPrice_fields}
	}
	IsActive
	Software {
		${software_fields}
	}
	Organization {
		OrganizationId
		Name
		Logo
	}
	Subscription {
		${Subscription_fields}
	}
	UserGroups {
		${UserGroup_fields}
	}
	UserGroupType {
		${UserGroupType_fields}
	}
	OptionIncluded {
		${OptionIncluded_fields}
	}
	Options {
		${Option_fields}
	}
`;

export const GET_ALLOPTIONS = gql`
query allOptions{ 
	allOptions{
		${Option_fields}
	}
}`;

export const GET_ALL_PRICING_PLANS = gql`
query plan{ 
	plan{
		${pricingPlan_fields}
	}
}`;

export const GET_PRICING_PLANS = gql`
query plan($OrganizationId: Int!) { 
	plan(data: {
		OrganizationId: $OrganizationId
	}) 
	{
		${pricingPlan_fields}
	}
}`;

export const CREATE_PRICING_PLAN = gql`
mutation createPlan(
	$Name: String!
	$UserGroupTypeId: Int!
	$PlanPrices: [PlanPriceInputType!]!
	$OrganizationId: Int
	$UserGroupIds: [Int!]
	$OptionIds: [Int!]
) {
	createPlan(
		data:{
			Name: $Name
			UserGroupTypeId: $UserGroupTypeId
			PlanPrices: $PlanPrices
			OrganizationId: $OrganizationId
			UserGroupIds: $UserGroupIds
			OptionIds: $OptionIds
		}
	) {
		${pricingPlan_fields}
	}
}
`;

export const UPDATE_PRICING_PLAN = gql`
mutation updatePlan(
	$PlanId: Int!
	$Name: String
	$UserGroupTypeId: Int
	$PlanPrices: [PlanPriceInputType!]
	$UserGroupIds: [Int!]
	$OptionIds: [Int!]
	$IsActive: Boolean
	$OrganizationId: Int
) {
	updatePlan(
		data:{
			PlanId: $PlanId
			Name: $Name
			UserGroupTypeId: $UserGroupTypeId
			PlanPrices: $PlanPrices
			UserGroupIds: $UserGroupIds
			OptionIds: $OptionIds
			IsActive: $IsActive
			OrganizationId: 	$OrganizationId
		}
	) {
		${pricingPlan_fields}
	}
}
`;

export const DELETE_PRICING_PLAN = gql`
    mutation deletePlan($PlanId: Int!) {
        deletePlan(data: { PlanId: $PlanId })
    }
`;
